import { render } from "./DataManager.vue?vue&type=template&id=1184c184&scoped=true"
import script from "./DataManager.vue?vue&type=script&lang=js"
export * from "./DataManager.vue?vue&type=script&lang=js"

import "./DataManager.vue?vue&type=style&index=0&id=1184c184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1184c184"]])

export default __exports__